import ArrowLeft from './src/arrow-left-combined';
export default ArrowLeft;